// extracted by mini-css-extract-plugin
export var chevron = "_32-d";
export var disabled = "_32-b";
export var error = "_32-c";
export var hideBorder = "_32-1";
export var icon = "_32-e";
export var input = "_32-0";
export var large = "_32-f";
export var open = "_32-9";
export var placeholder = "_32-a";
export var regular = "_32-5";
export var singleRowInput = "_32-2";
export var singleSelectInput = "_32-3 _32-0";
export var small = "_32-4";
export var spinnerContainer = "_32-i";
export var tag = "_32-7";
export var tagsContainer = "_32-8";
export var tagsInput = "_32-6 _32-0";
export var xSmall = "_32-g";
export var xxSmall = "_32-h";